
/**
 * 验证用户名（中文、英文、数字）
 * @param obj
 */
// function isHasRight(rightName) {
// function isHasRight('M000000','103') {
function isHasRight(val1,val2,val3) {
    let result = false;
    const userlight = JSON.parse(sessionStorage.getItem('userlight'));
        if(val1!=null && val2==null && val3==null){
            for(let i=0;userlight.length>i;i++){
                if(userlight[i].id==val1 && userlight[i].check==true){
                    result= true;
                    break;
                }
            }
        }
        if(val1!=null && val2!=null && val3==null){
            for(let i=0;userlight.length>i;i++){
                if(userlight[i].id==val1 && userlight[i].check==true){
                    for(let b=0;userlight[i].childes.length>b;b++){
                        if(userlight[i].childes[b].id==val2 && userlight[i].childes[b].check==true){
                            result= true;
                            return result;
                        }
                    }
                    
                }
            }
        }
        if(val1!=null && val2!=null && val3!=null){
            for(let i=0;userlight.length>i;i++){
                if(userlight[i].id==val1 && userlight[i].check==true){
                    for(let b=0;userlight[i].childes.length>b;b++){
                        if(userlight[i].childes[b].id==val2 && userlight[i].childes[b].check==true){
                            for(let c=0;userlight[i].childes[b].childes.length>c;c++){
                                if(userlight[i].childes[b].childes[c].id==val3 && userlight[i].childes[b].childes[c].check==true){
                                    result= true;
                                    return result;
                                }
                            }
                        }
                    } 
                }
            }
        }
    return result;
}
  export default {
    isHasRight,
  };




// WEBPACK FOOTER //
// ./src/assets/js/userRight.js